// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingInvoiceLineResponse

import { BillingInvoiceLineType, BillingDiscountType } from './enums.gen';

export type BillingInvoiceLineApiResponse = {
	id: number;
	description: string;
	amount: number;
	quantity: number;
	type: BillingInvoiceLineType;
	discountType: BillingDiscountType | null;
	discountValue: number | null;
};

export type BillingInvoiceLine = {
	id: number;
	description: string;
	amount: number;
	quantity: number;
	type: BillingInvoiceLineType;
	discountType: BillingDiscountType | null;
	discountValue: number | null;
};

export function hydrateBillingInvoiceLine(data: BillingInvoiceLineApiResponse): BillingInvoiceLine {
	return { ...data };
}